import { useLocales } from '@shared/locales'
import { Form, Input } from 'antd'

export const FormNomenclaturesCountries = () => {
  const { t } = useLocales()

  return (
    <>
      <Form.Item
        name="name"
        label={t('nomenclature.name')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="code"
        label={t('nomenclature.code')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item name="continent" label={t('nomenclature.continent')}>
        <Input />
      </Form.Item>
    </>
  )
}
